import {
  REFERRAL_SESSION_STORAGE_KEY,
  ReferralData,
  type ReferralDataType,
} from '../../defs';

/**
 * Reads captured cookbook-referral attribution from session storage. Returns
 * `null` when nothing was captured or the stored value is malformed — callers
 * should treat that as "no referral" rather than letting it throw mid-signup.
 */
export function getReferralSessionStorage(): ReferralDataType | null {
  const raw = sessionStorage.getItem(REFERRAL_SESSION_STORAGE_KEY);
  if (raw === null) return null;

  try {
    const result = ReferralData.safeParse(JSON.parse(raw));
    return result.success ? result.data : null;
  } catch {
    return null;
  }
}
